import { useContext } from 'react'

import { WindowsCreateOrEditContext } from '@pages/WindowsCreateOrEdit/WindowsCreateOrEdit'

import { Variables } from '@components/Variables'

import { ENTITY_TYPES_REQUEST } from '@constants'

export const VariablesWrapper = () => {
  const { windowId, isEdit } = useContext(WindowsCreateOrEditContext)

  return (
    <Variables entityId={windowId} entityType={ENTITY_TYPES_REQUEST.WINDOW} isEditEntity={isEdit} />
  )
}
